import { ReactNode, useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse, Box, useMediaQuery, useTheme } from "@mui/material";

interface CollapsableBoxProps {
    title: string;
    children: ReactNode;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
}

const CollapsableBox: React.FC<CollapsableBoxProps> = ({ title, children, isOpen, setIsOpen }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [height, setHeight] = useState("0px");
    const timeoutRef = useRef<any>(null);
    const firstLoad = useRef(true);

    useEffect(() => {
        if (firstLoad.current) {
            firstLoad.current = false;
        }else{
            if (isOpen) {
                setHeight(`${document.getElementById("hmmm")?.getBoundingClientRect().height}px`);
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setHeight("max-content");
                }, 500);
            } else {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                setHeight(`${document.getElementById("hmmm")?.getBoundingClientRect().height}px`);
                setTimeout(() => {
                    setHeight(`0px`);
                }, 50);
            }
        }
    }, [isOpen]);

    return (
        <div className="collapsable-box">
            <div className={`accordion ${isMobile ? "mobile" : ""} ${title === "Add Account" ? "add-account" : ""}`}>
                <div onClick={() => setIsOpen(!isOpen)} className="accordion-title">
                    {title}
                    <ExpandMoreIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "0.5s" }} className="expand-icon" fontSize="large" />
                </div>
                <div style={{ height }} className="accordion-details">
                    <div id="hmmm">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default CollapsableBox;
